<div class="modal-passkeys">
  <div class="modal-passkeys__header">
    <span class="modal-passkeys__header__title">
      {{ textTranslate.title }}
    </span>
    <div class="modal-passkeys__header__close">
      <mat-icon (click)="dialogRef.close()" class="">close</mat-icon>
    </div>
  </div>
  <div class="modal-passkeys__body">
    <div class="modal-passkeys__body__img">
      <img
        src="https://cdn.mango-soft.com/access-control/passkeys-img.svg"
        alt=""
      />
    </div>
    <div class="modal-passkeys__body__text">
      <span>
        {{ textTranslate.text }}
      </span>
    </div>
    <div *ngIf="!loading">
      <div
        class="modal-passkeys__body__passkey"
        [ngClass]="{ active: !device.disable }"
        *ngFor="let device of devices"
      >
        <div class="modal-passkeys__body__passkey__name">
          <mat-icon>devices</mat-icon>
          <input
            type="text"
            class="input-edit"
            [value]="device.name"
            (input)="onInputDevice($event)"
            *ngIf="!device.disable"
          />
          <span *ngIf="device.disable"> {{ device?.name }} </span>
        </div>
        <div class="modal-passkeys__body__passkey__options">
          <mat-icon *ngIf="device.disable" (click)="activeEdit(device)"
            >edit</mat-icon
          >
          <mat-icon *ngIf="!device.disable" (click)="cancelEdit()"
            >cancel</mat-icon
          >
          <mat-icon *ngIf="!device.disable" (click)="saveEditDevice(device)"
            >save</mat-icon
          >
          <div class="delete" *ngIf="!device.disable">
            <mat-icon [matMenuTriggerFor]="menu" #menuTrigger>delete</mat-icon>
            <mat-menu
              class="modal-passkeys__body__passkey__options__menu"
              #menu="matMenu"
            >
              <div class="modal-passkeys__body__passkey__options__menu">
                <div class="modal-passkeys__body__passkey__options__text">
                  <span>{{ textTranslate.messageConfirmDeletePasskey }}</span>
                </div>
                <div
                  class="modal-passkeys__body__passkey__options__menu__options"
                >
                  <button
                    (click)="deleteDevice(device)"
                    class="modal-passkeys__body__passkey__options__menu__options__confirm"
                  >
                    <span> {{ textTranslate.optionDelete }} </span>
                  </button>
                  <button
                    class="modal-passkeys__body__passkey__options__menu__options__cancel"
                  >
                    <span>No</span>
                  </button>
                </div>
              </div>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loading" class="loading">
      <img src="https://cdn.mango-soft.com/mango-core/Ellipsis.gif" />
    </div>
    <div
      class="modal-passkeys__body__passkeys"
      (click)="addPassKey()"
      *ngIf="validateUsePasskeys()"
    >
      <mat-icon>add</mat-icon>
      <span> {{ textTranslate.buttonNew }} </span>
    </div>
    <div
      class="modal-passkeys__body__notPasskey"
      *ngIf="!validateUsePasskeys()"
    >
      <span>{{ textTranslate.messageNotPasskey }} </span>
    </div>
  </div>
  <div class="footer-modal modalAction">
    <!-- <button class="mg-button ">Save</button> -->
    <button (click)="dialogRef.close()" class="mg-button secundaryButton">
      {{ textTranslate.buttonClose }}
    </button>
  </div>
</div>
